import React from "react";

import Dropdown, { DropdownOption } from "./Dropdown";
import { ISO_COUNTRY_OPTIONS } from "./consts";

interface CountryDropdownProps {
  value: DropdownOption | null;
  onChange: (value: DropdownOption | null) => void;
  placeholder?: string;
  className?: string;
}

const CountryDropdown: React.FC<CountryDropdownProps> = ({
  value,
  onChange,
  placeholder = "Select a country",
  className,
}) => {
  return (
    <Dropdown
      options={ISO_COUNTRY_OPTIONS as DropdownOption[]}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={className}
    />
  );
};

export default CountryDropdown;
